import React from 'react';
import { Text, Flex, Pane } from '@leverege/ui-elements';
import { ns } from '@leverege/i18n';
import S from './PieRolloverCard.css';
const {
  t
} = ns('ui-attributes-graphs.viewers.PieRolloverCard');
function PieRolloverCard(props) {
  const {
    active,
    top: pTop,
    left: pLeft,
    rollover,
    key
  } = props;
  const top = pTop + active.y;
  const left = pLeft + active.x;
  const shift = !key && pLeft < 250 && top >= 160 && top <= 290 && pLeft / left > 0.6;
  const percent = active.percent.toString().includes('.') ? Number(active.percent).toFixed(2) : active.percent;
  return /*#__PURE__*/React.createElement(Pane, {
    variant: rollover?.paneVariant,
    className: S.pane,
    style: {
      position: 'absolute',
      top,
      left: shift ? left - left * 2 / 5 : left
    }
  }, rollover.labelVisible && /*#__PURE__*/React.createElement(Flex, {
    variant: rollover.labelFlexVariant,
    className: S.flex
  }, /*#__PURE__*/React.createElement(Text, {
    variant: rollover?.labelTextVariant
  }, active.name)), rollover.countVisible && /*#__PURE__*/React.createElement(Flex, {
    variant: rollover?.countFlexVariant || 'rowSpaceBetween',
    className: S.flex
  }, /*#__PURE__*/React.createElement(Text, {
    variant: rollover?.countTextVariant,
    className: S.text
  }, t('count')), /*#__PURE__*/React.createElement(Text, {
    variant: rollover?.countValueVariant,
    className: S.text
  }, active?.value)), rollover.percentVisible && /*#__PURE__*/React.createElement(Flex, {
    variant: rollover?.percentFlexVariant || 'rowSpaceBetween',
    className: S.flex
  }, /*#__PURE__*/React.createElement(Text, {
    variant: rollover?.percentTextVariant,
    className: S.text
  }, t('percent')), /*#__PURE__*/React.createElement(Text, {
    variant: rollover?.percentValueVariant,
    className: S.text
  }, `${percent}%`)));
}
export default PieRolloverCard;